import { MatTooltipDefaultOptions } from '@angular/material/tooltip';

export const EXPIRE_TIME_IN_SECONDS = 900;
export const MAT_TOOLTIP_OPTIONS: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 100,
  touchendHideDelay: 100,
  touchGestures: 'on',
};
